import React from 'react';
import { Divider as SpectrumDivider } from '@adobe/react-spectrum';
import { getDirectionDivider, getPerpendicularDirection, } from 'app/utils/varia';
const MarginForOrientation = {
    vertical: { marginX: 'size-0' },
    horizontal: { marginY: 'size-200' },
};
export const Divider = () => {
    const direction = getPerpendicularDirection(configGet('desktopMainViewLayout', 'row'));
    const orientation = getDirectionDivider(direction);
    return (React.createElement(SpectrumDivider, Object.assign({ size: "S" }, MarginForOrientation[orientation], { orientation: orientation })));
};
